import { Folder } from '../models';

export function findFolderInTree(
  id: string,
  folders: Folder[],
  path: Folder[] = []
): [Folder | undefined, Folder[]] {
  for (let folder of folders) {
    if (folder.id === id) {
      return [folder, path];
    } else if (folder.subFolders && folder.subFolders.length > 0) {
      const [found, foundPath] = findFolderInTree(id, folder.subFolders, [
        ...path,
        folder,
      ]);

      if (found) {
        return [found, foundPath];
      }
    }
  }

  return [undefined, []];
}
